import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { notificationsApi } from '../lib/notifications-api'

/**
 * Header bell reachable from every authenticated role (see App.tsx) since
 * notification recipients span HSE_OFFICER, contractor users, and — for
 * gate-denial/mismatch alerts — HSE regardless of which console they're in.
 * Polls rather than using a push channel: Cloudflare Workers free tier has no
 * always-on process to hold a websocket/SSE connection open (ponytail: poll
 * is the YAGNI-simplest option; upgrade path is a Durable Object + WebSocket
 * if near-real-time delivery becomes a requirement).
 */
export function NotificationsBell() {
  const { t } = useTranslation('common')
  const [unreadCount, setUnreadCount] = useState(0)

  useEffect(() => {
    let cancelled = false
    const poll = async () => {
      try {
        const { data } = await notificationsApi.list({ unreadOnly: true, pageSize: 1 })
        if (!cancelled) setUnreadCount(data.unreadCount)
      } catch {
        // best-effort — a failed poll should never break the header
      }
    }
    void poll()
    const interval = setInterval(poll, 60_000)
    return () => {
      cancelled = true
      clearInterval(interval)
    }
  }, [])

  return (
    <Link
      to="/notifications"
      className="relative inline-flex min-h-touch min-w-touch items-center justify-center rounded-md text-slate-700 hover:bg-slate-50"
      aria-label={t('nav.notifications')}
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className="h-6 w-6" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.2V11a6 6 0 1 0-12 0v3.2a2 2 0 0 1-.6 1.4L4 17h5m6 0v1a3 3 0 1 1-6 0v-1m6 0H9"
        />
      </svg>
      {unreadCount > 0 && (
        <span className="absolute right-0.5 top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-semibold leading-none text-white">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </Link>
  )
}
